import { render, staticRenderFns } from "./editPromoVoucherEndDate.vue?vue&type=template&id=790849a4&lang=pug"
import script from "./editPromoVoucherEndDate.vue?vue&type=script&lang=js"
export * from "./editPromoVoucherEndDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports